export default {
  // 1-3
  GET_EMPLOYEE_DETAIL(state, data) {
    state.employeeDetail = data.data.employee;
    state.attachment = data.data.attachment;
  },
};
